module.exports = __webpack_public_path__ + "static/WelcomeToElk3-8bde95e2c4b73e13f9c28a9d9fbd11a8.png";